angular
  .module('gm.common.items', [
    'gm.common.common',
    'gm.common.user'
  ]);
